module.exports = __webpack_public_path__ + "img/6pgb5100.c83b9155.jpg";